import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PublicLayout } from "@/components/PublicLayout";
import api from "@/lib/api";
import { Loader, EmptyState } from "@/components/shared";
import { PlansBackdrop, PlansHero, GlowCta } from "@/components/PlanVisuals";
import { Reveal } from "@/components/ShareVisuals";
import { ShowcaseCard, FeaturedCard, ProjectDetailDialog, useLightMode } from "@/components/ProjectShowcase";

export default function Projects() {
  const [items, setItems] = useState(null);
  const [featured, setFeatured] = useState(null);
  const [active, setActive] = useState(null);
  const { light, reduce } = useLightMode();
  useEffect(() => {
    api.get("/projects").then((r) => setItems(r.data)).catch(() => setItems([]));
    api.get("/projects/featured").then((r) => setFeatured(r.data)).catch(() => setFeatured(null));
  }, []);
  return (
    <PublicLayout>
      <section className="relative overflow-hidden" data-testid="public-projects">
        <PlansBackdrop />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 pt-16 pb-20">
          <PlansHero eyebrow="Upcoming Projects" title="The Next Wave of AI TECHNOLOGY"
            subtitle="A roadmap of AI products and services currently in planning and development. Each project is announced ahead of launch so our community can follow progress." />
          {featured && <FeaturedCard data={featured} onOpen={setActive} light={light} reduce={reduce} />}
          {items === null ? <Loader /> : items.length ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" style={{ perspective: 1200 }}>
              {items.map((p, i) => <ShowcaseCard key={p.id} project={p} index={i} onOpen={setActive} light={light} reduce={reduce} />)}
            </div>
          ) : <EmptyState title="No projects announced yet" subtitle="Check back soon." />}
          <Reveal delay={0.1} className="text-center mt-14">
            <p className="text-sm text-slate-400 mb-5">Want early access as projects go live? Create your account today.</p>
            <div className="max-w-xs mx-auto"><GlowCta as={Link} to="/signup" testId="projects-cta">Get Started</GlowCta></div>
          </Reveal>
        </div>
      </section>
      <ProjectDetailDialog project={active} onClose={() => setActive(null)} reduce={reduce} />
    </PublicLayout>
  );
}
